"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.load.error': 'Nie udało się załadować danych slotu',
};
